import { Box } from '@user-portal/wikr-components';
import styled from 'styled-components';

export const SkeletonWrapper = styled(Box)`
    width: 100%;
`;
